import {FirebaseAuthProvider} from "react-admin-firebase";
import firebase from 'firebase';
import { firebaseConfig } from './FIREBASE_CONFIG';

const firebaseApp = !firebase.apps.length ? firebase.initializeApp(firebaseConfig) : firebase.apps[0];

const options = {
    logging: true,
    // rootRef: 'rootrefcollection/QQG2McwjR2Bohi9OwQzP',
    app: firebaseApp,
    // watch: ['posts'];
    // dontwatch: ['comments'];
    persistence: 'local',
    // disableMeta: true
    dontAddIdFieldToDoc: true
};

export default FirebaseAuthProvider(firebaseConfig, options);
